<template>
  <div style="height:100%;background:#fff;margin:0 -50px;padding:0 50px;">
    <div class="logo fl" :style="{backgroundImage:'url('+logo+')'}">{{title}}</div>
    <!--  <ul class="links zoom fr">
       <li class="fl"><router-link to="商务">商务合作</router-link></li>
       <li class="fl"><router-link to="了解超级码">了解超级码</router-link></li>
       <li class="fl"><router-link to="联系我们">联系我们</router-link></li>
     </ul> -->
  </div>
</template>
<script>
  import enums from '../../enums/index.js'
  import logoPath from '../../../static/logo.png';
  export default {
    computed: {
      title(){
        const individuationSetting = this.$store.state.individuationSetting;
        return individuationSetting.pageLogoType == enums.LogoTypeTxt ? individuationSetting.pageTitle : '';
      },
      logo(){
        const individuationSetting = this.$store.state.individuationSetting;
        let logo = '';
        if (individuationSetting.pageLogoType == enums.LogoTypeImg) {
          logo = individuationSetting.pageLogo;
        } else if (individuationSetting.pageLogoType == null) {
          logo = logoPath;
        }
        return logo;
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/less/base.less';

  .logo {
    font-size: 48px;
    width: 60%;
    margin-top: 27px;
    height: 66px;
    line-height: 66px;
    background: left center no-repeat;
    background-size: contain;
    box-sizing: border-box;
    white-space: nowrap;
  }

  .links li {
    list-style: none;
  }

  .links li:before {
    font-size: @font-size-normal;
    content: '/';
    display: inline-block;
    text-align: center;
    width: 28px;
  }

  .links li:first-child:before {
    display: none;
  }

  .links a {
    font-size: @font-size-small;
    color: lighten(@color-black, 30%);
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// head.vue?66f358e8